<drawer *ngIf="institution" [title]="institution.id ? 'Edit institution' : 'Add institution'"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[noContentPadding]="false"
	[isClosed]="false"
	(saveEvent)="submit()"
	(cancelEvent)="closeLayer()"
	(closeEvent)="closeLayer()">
	<div class="drawer-content drawer-direct-content">
		<form name="institutionForm" role="form">
			<div class="row fields-group mt-4">
				<div class="col-lg-6 col-md-12">
					<label class="input-label field-required">{{'annexes.inst.name' | translate}}</label>
					<input
						class="form-control"
						type="text"
						name="name"
						[(ngModel)]="institution.name"
						#name="ngModel"
						[rangeLength]="[2, 256]"
						required
						placeholder="{{ 'annexes.inst.name_placeholder' | translate }}"
						autofocus
						(input)="isNew(institution.id) || nameChanged($event.target.value)"/>
					<p class="validation-error" *ngIf="name?.errors?.required && (name?.dirty && name?.touched)">
						{{ 'form.validate.required' | translate }}
					</p>
					<p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
						{{ 'form.validate.minLenght' | translate }} 2!
					</p>
					<p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
						{{ 'form.validate.maxLenght' | translate }} 256!
					</p>
				</div>
				<div class="col-lg-6 col-md-12">
					<label class="input-label">{{'annexes.inst.shortname' | translate}}</label>
					<input
						class="form-control"
						type="text"
						name="shortName"
						[(ngModel)]="institution.shortName"
						placeholder="{{ 'annexes.inst.shortname_placeholder' | translate }}"
						maxlength="20"/>
				</div>
			</div>
			<div class="row fields-group">
				<div class="col-lg-12 col-md-12 mb-3 mb-lg-0">
					<label class="input-label">{{'annexes.inst.url_placeholder' | translate}}</label>
					<input
						class="form-control"
						type="text"
						name="url"
						[(ngModel)]="institution.url"
						placeholder="{{ 'annexes.inst.url_placeholder' | translate }}"/>
				</div>
			</div>
		</form>
	</div>
</drawer>